module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.22896b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_hero.png
// module id = Z2b3
// module chunks = 0